import typeCheck from 'common/util/typeCheck';

import {
  hasRoleAdmin,
  hasRolePartnerPropertyManager,
  hasRoleGroupAdmin,
} from 'common/utility/userRoles';

import { SR_API_ACTION_UTILITY_PARTNER_GROUP_GET_PARTNERS } from 'api/utilityActionTypes';

export default async function getPartnersInGroup(
  { state, utilityApiClient },
  { utilityPartnerGroupId, forceRefresh = false },
) {
  typeCheck('utilityPartnerGroupId::PositiveNumber', utilityPartnerGroupId);

  const partnersInGroupStatePath = ['utilityPartners', 'byPartnerGroupId', utilityPartnerGroupId];
  const utilityUser = state.get(['utilityUser']);

  const canAccessToPartnerGroup =
    utilityUser &&
    (hasRoleGroupAdmin(utilityUser.roles) ||
      hasRoleAdmin(utilityUser.roles) ||
      hasRolePartnerPropertyManager(utilityUser.roles));

  if (!canAccessToPartnerGroup) {
    return;
  }

  if (state.get(partnersInGroupStatePath) && !forceRefresh) {
    return state.get(partnersInGroupStatePath);
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_PARTNER_GROUP_GET_PARTNERS,
    queryId: utilityPartnerGroupId,
    state: state,
    payload: {
      utilityPartnerGroupId,
    },
    onSuccess(partnersInGroup) {
      if (partnersInGroup) {
        state.set(partnersInGroupStatePath, partnersInGroup);
      }
    },
  });
}
